import { Text } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';
import { NotCapturingErrors } from './NotCapturingErrors';
import { Container, CheckIcon, Subtitle } from './styles';

type Props = {
  isCapturingErrors: boolean;
  siteId?: number;
  hasEnabledCapture: boolean;
  onEnableCapture: () => void;
};

export const EmptyState = ({
  isCapturingErrors,
  siteId,
  hasEnabledCapture,
  onEnableCapture,
}: Props): JSX.Element | null => {
  const { t } = useTranslation();
  // TODO: Replace with shared component once RECS-1555 is done
  if (!isCapturingErrors) {
    return (
      <NotCapturingErrors
        siteId={siteId}
        hasEnabledCapture={hasEnabledCapture}
        onEnableCapture={onEnableCapture}
      />
    );
  }

  return (
    <Container>
      <CheckIcon size="l" icon="info" color="text_light" />

      <Text textType="subtitle1">{t('common:player.console-empty-title')}</Text>
      <Subtitle textType="body2">{t('common:player.console-empty-subtitle')}</Subtitle>
    </Container>
  );
};
